<!--
The purpose of this component is to hide/show components while still keeping their physical size
i.e. for transitioning to the element before it is shown
-->

<template>
  <transition>
    <slot></slot>
  </transition>
</template>

<script>
import _ from 'lodash';

const availableTransitions = [
  'fade',
  'slidex-right',
  'slidex-left',
  'slidey-down',
  'slidey-up',
];

export default {
  inheritAttrs: false,

  props: {
    transition: {
      type: String,
      default: 'fade',
      validator: (val) => _.includes(availableTransitions, val.toLowerCase()),
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    transitionClassName: function() {
      return `lt-bt-${this.transition}`;
    }
  },

  watch: {
    isActive(newVal) {
      this.$el.classList.toggle('lt-bt-is-active', newVal);
    },
  },

  mounted() {
    this.$el.classList.add(this.transitionClassName);
    if (this.isActive === true) {
      this.$el.classList.add('lt-bt-is-active');
    }
  },

};
</script>

<style lang='scss'>

$defaultTransition: .3s ease-out;

@mixin transition($name) {
  .lt-bt-#{$name} {
    @content;
  }
}

@mixin is-active {
  &.lt-bt-is-active {
    @content;
  }
}

@include transition('fade') {
  opacity: 0;
  transition: opacity $defaultTransition;
  @include is-active {
    opacity: 1;
  }
}

@include transition('slidex-right') {
  opacity: 0;
  transform: translateX(-20px) translateZ(0);
  transition: opacity $defaultTransition, transform $defaultTransition;
  @include is-active {
    opacity: 1;
    transform: translateX(0) translateZ(0);
  }
}

@include transition('slidex-left') {
  opacity: 0;
  transform: translateX(20px) translateZ(0);
  transition: opacity $defaultTransition, transform $defaultTransition;
  @include is-active {
    opacity: 1;
    transform: translateX(0) translateZ(0);
  }
}

@include transition('slideY-down') {
  opacity: 0;
  transform: translateY(-20px) translateZ(0);
  transition: opacity $defaultTransition, transform $defaultTransition;
  @include is-active {
    opacity: 1;
    transform: translateY(0) translateZ(0);
  }
}

@include transition('slideY-up') {
  opacity: 0;
  transform: translateY(20px) translateZ(0);
  transition: opacity $defaultTransition, transform $defaultTransition;
  @include is-active {
    opacity: 1;
    transform: translateY(0) translateZ(0);
  }
}

</style>
